import React from 'react';
import MetronicLayout from './MetronicLayout';

/**
 * AppLayout
 * Shared application shell for authenticated pages.
 * Wraps content in the Metronic layout (header + sidebar + main area).
 */
export function AppLayout({ children }) {
  return (
    <MetronicLayout>
      {children}
    </MetronicLayout>
  );
}

export default AppLayout;

